import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Option from './Option'

const propTypes = {
  items: PropTypes.array.isRequired,
  selectedItem: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.bool,
  ]),
  onSelectChange: PropTypes.func.isRequired,
}

class Dropdown extends Component {
  constructor(props) {
    super(props)

    this.onSelectChange = this.onSelectChange.bind(this)
    this.optionsFactory = this.optionsFactory.bind(this)
    this.visibleValue = this.visibleValue.bind(this)
  }

  onSelectChange(evt) {
    const { onSelectChange } = this.props

    // call parent onSelectChange method
    if (typeof onSelectChange === 'function') {
      onSelectChange(evt.target.value)
    }
  }

  // option elements render
  optionsFactory() {
    const { items } = this.props

    return items.map((item) => {
      const hasChilds = !!item.folder

      return (
        <Option
          key={item.id}
          value={item.id}
          text={item.text}
          type={hasChilds ? 'parent' : 'child'}
        />
      )
    })
  }

  visibleValue(selected, list, placeholder) {
    return selected && list.filter((item) => item.id === selected).length
      ? selected
      : placeholder
  }

  render() {
    const { selectedItem, items, title, unselectedText } = this.props
    const unselected = ''

    return (
      <wb-select-control>
        <wb-select>
          <label>{title || 'Tenant'}</label>
          <select onChange={this.onSelectChange}>
            <option disabled={false} value={unselected}>
              {unselectedText || 'Select a tenant..'}
            </option>
            {this.optionsFactory()}
          </select>
        </wb-select>
      </wb-select-control>
    )
  }
}

Dropdown.propTypes = propTypes

export default Dropdown
